import { BannersConfig, DeepPartial } from '@empathybroker/ebx-gluon';

export const MOBILE_BANNERS: DeepPartial<BannersConfig> = { position: 'first' };
